import { BusIcon } from "./TransportTypeIcon/BusIcon";
import { RERIcon } from "./TransportTypeIcon/RERIcon";
import { TrainIcon } from "./TransportTypeIcon/TrainIcon";
import { TramIcon } from "./TransportTypeIcon/TramIcon";
import { MetroIcon } from "./TransportTypeIcon/MetroIcon";
import { TransportType } from "@/location/types";
export const transportIconMap = {
    [TransportType.BUS]: BusIcon,
    [TransportType.TRAIN]: TrainIcon,
    [TransportType.TRAM]: TramIcon,
    [TransportType.METRO]: MetroIcon,
    [TransportType.URBAN_TRAIN]: TrainIcon,
    [TransportType.RER]: RERIcon,
};
